import React, {useMemo} from 'react'
import utils from 'helpers/utils';
import ApplicantPage from 'components/pages/Portal/ApplicantPage/ApplicantPage';

export default function usePortalRoutes () {
  return useMemo(() => {
    const route = [
      {
        path: 'applicant',
        element: <ApplicantPage />,

        handle: {
          title: 'Applicant',
          auth: utils.createAuth({
            meta: {
              portal: true
            }
          })
        }
      }
    ];

    return {
      WrapperComponent: React.Fragment,
      route: route
    };
  }, []);
};
